import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import noImage from './images/no-image.svg';
import Config from '../../../../Config';
import PremiumPackagePopup from './PremiumPackagePopup'
const PremiumPackages = (props) => {
  useEffect(() => {
    console.info('props.premiumPackages', props.premiumPackages);
    props.premiumPackages.map(function (item, i) {
      if (item.isDefault && item.vasList.length == 1) {
        props.onPremiumPackageChange(item.id, item.vasList[0]?.id, true);  
      }
    });
  }, []);

  return (
    <div className='premium-packages-wrapper'>
      {props.premiumPackages && props.premiumPackages.length > 0 &&
        props.premiumPackages.map(function (item, i) {
          const image = item.image ?  Config.epiBaseUrl + item.image : noImage;

          return (
            <>
              <div className='premium-package' key={item.id}>
                <Image src={image} alt={item.title} />

                <div className="premium-package-datails">
                  <div className='title-and-price'>
                    <div className='title-wrapper'>
                      <div>
                        <CheckBox checked={item.isSelected} label={item.title} id={item.id} onChange={() => handleOnPremiumPackageChange(item, !item.isSelected)}></CheckBox>
                      </div>
                    </div>
                    <div className='price-wrapper'>
                          <Price price={item.price} priceText={item.priceText} vasList={item.vasList} />
                    </div>
                  </div>
                  <div className='details-wrapper'>
                    <a className='details' href='javascript: void(0)' onClick={() => {setPopUp(item.id, true);}}>
                      לפרטים
                    </a>
                  </div>
                </div>
              </div>

              <PopUp showPopUp={item.isOpenPopUp} onClose={() => { setPopUp(item.id, false); }} className='premium-package-popup-wrapper'>
                <PremiumPackagePopup premiumPackage={item} onVasSelected={handleOnVasSelected} />
              </PopUp>
            </>
          );
        })}
    </div>
  );

  function handleOnPremiumPackageChange(item, isSelected) {
    if (item.isMandatory) { return; }
    if (item.vasList.length > 1) {
      if (isSelected) {
        props.onPopupChange(item.id, true);
      }
      else {
        const premiumPackage = props.premiumPackages.find(x => x.id == item.id);
        const vas = premiumPackage.vasList.find(x => x.isSelected);
        props.onPremiumPackageChange(premiumPackage?.id, vas?.id, false);
      }      
      return;
    }
    props.onPremiumPackageChange(item.id, item.vasList[0]?.id, isSelected);
  }

  function handleOnVasSelected(premiumPackageId, vasId) {  

    //----------- unselect current vas -----------
    const premiumPackage = props.premiumPackages.find(x => x.id == premiumPackageId);
    const vas = premiumPackage.vasList.find(x => x.isSelected);
    if (vas) {
      props.onPremiumPackageChange(premiumPackage?.id, vas?.id, false);
    }    
    //----------- unselect current vas -----------
    
    props.onPremiumPackageChange(premiumPackageId, vasId, true);
    props.onPopupChange(premiumPackageId, false);
  }

  function setPopUp(id, isOpenPopUp) {
    props.onPopupChange(id, isOpenPopUp);
  }

};

const Price = (props) => {
    if (props.price == '' || props.price == '0') {
        return (<div className='price'>כלול בחבילה</div>)
    }
    else {
        return (
            <>
                <div className='price'>
                  {props.vasList.length > 1 && (
                    <span className="price-prefix">החל מ-</span>
                  )}                  
                  ₪{props.price}
                </div>
                {props.priceText && props.priceText != '' && 
                    <div className='price-text'>{props.priceText}</div>
                }
            </>             
        )
    }
}

export default PremiumPackages;
